export default __webpack_public_path__ + "static/media/logo-dark.f6b71fbd.png";